var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 367,
    viewBox: "0 0 324 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.583 26.7083C315.507 25.2754 313.11 24.3741 310.604 24.0835C308.097 23.793 305.558 24.122 303.208 25.0417C278.469 35.7638 252.285 42.7836 225.5 45.875C208.581 41.3498 192.432 34.3282 177.583 25.0417C158.42 13.1976 137.23 5.004 115.083 0.875019C88.2083 -1.62498 24.25 19.4167 10.9166 23.7917C7.8216 24.8371 5.13208 26.8262 3.22623 29.4795C1.32038 32.1327 0.294079 35.3166 0.291626 38.5834V350.667C0.291626 354.811 1.93782 358.785 4.86808 361.715C7.79834 364.645 11.7726 366.292 15.9166 366.292C20.0606 366.292 24.0349 364.645 26.9652 361.715C29.8954 358.785 31.5416 354.811 31.5416 350.667V228.583C57.5123 219.38 84.5239 213.431 111.958 210.875C129.598 215.205 146.463 222.232 161.958 231.708C180.086 242.789 199.945 250.746 220.708 255.25H225.5C255.655 251.348 285.152 243.43 313.208 231.708C316.137 230.548 318.652 228.541 320.434 225.943C322.215 223.345 323.181 220.275 323.208 217.125V39.625C323.365 37.18 322.936 34.7329 321.958 32.4866C320.979 30.2403 319.48 28.2595 317.583 26.7083V26.7083Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Flag.208ab2a1ec363b00b2bb7a07354bb25e.svg";